(ns pfo.collection.controller
  (:require-macros [pfo.macros :refer [defcontroller]])
  (:require
   [pfo.api :as api  :refer [process-error]]
   [pfo.auth.model :as auth-model]
   [promesa.core :as p]
   [pfo.collection.model :as model]
   [keechma.next.controller :as ctrl]
   [pfo.util :as util]
))

(derive :permitted-groups :keechma/controller)
(defmethod ctrl/handle :permitted-groups
  [{:keys [state*] :as ctrl} event {:keys [collection-id admin-only on-success aark-enabled]}]
  (case event
    :load (->> (model/permitted-groups collection-id)
               (p/map (fn [groups] 
                        (ctrl/transact ctrl #(reset! state* (model/aark-enabled-only 
                                                             (if admin-only
                                                               (auth-model/only-admin-groups groups)
                                                               groups)
                                                             aark-enabled
                                                             )))
                        (some-> on-success (apply [groups]))))
               (process-error))
    nil))

(derive :family-collection-list :keechma/controller)
(defmethod ctrl/handle :family-collection-list
  [{:keys [state*] :as ctrl} event {:keys [family-id page order include-dispositions disposition-uid collection-name label-ids]}]
  (case event
    :load (->> (model/family-collection-list family-id page order include-dispositions disposition-uid collection-name label-ids)
                 (p/map (fn [collections] (ctrl/transact ctrl #(reset! state* collections))))
                 (process-error))
    nil))

(derive :collection-details :keechma/controller)
(defmethod ctrl/handle :collection-details
  [{:keys [state*] :as ctrl} event {:keys [collection-id on-success]}]
  (case event
    :load (->> (model/collection-details collection-id)
                 (p/map
                   (fn [collection]
                     (ctrl/transact ctrl #(reset! state* collection))
                     (some-> on-success (apply [collection]))))
                 (process-error))
    :clear (reset! state* nil)
         nil))

(derive :collection-list :keechma/controller)
(defmethod ctrl/handle :collection-list
  [{:keys [state*] :as ctrl} event {:keys [parent-id include-intermediate]}]
  (case event
    :load (->> (api/ajaxp "/collections/" {:params {:parent_id (or parent-id "")
                                                    :include_intermediate include-intermediate}})
            (p/map (fn [collections] (ctrl/transact ctrl #(reset! state* collections))))
            (process-error))
    :clear (reset! state* nil)
    nil))

(derive :collection-tree :keechma/controller)
(defmethod ctrl/handle :collection-tree
  [{:keys [state*] :as ctrl} event {:keys [family-id include-inactive filter-options cb]}]
  (case event
    :load (->> (model/collection-tree family-id true include-inactive filter-options)
            (p/map (fn [response]
                     (if cb
                       (cb response)
                       (ctrl/transact ctrl #(reset! state* response)))))
            (process-error))
    nil))

(derive :permitted-users :keechma/controller)
(defmethod ctrl/handle :permitted-users
  [{:keys [state*] :as ctrl} event {:keys [collection-ids on-success]
                                    :as params}]
  (case event
    :load (->> (model/permitted-users (dissoc params :collection-ids) collection-ids)
               (p/map
                 (fn [users-response]
                   (ctrl/transact ctrl #(reset! state* users-response))
                   (some-> on-success (apply [users-response]))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :boir-preview :keechma/controller)
(defmethod ctrl/handle :boir-preview
  [{:keys [state*] :as ctrl} event {:keys [collection-id filing-type type]}]
  (case event
    :load (->> (model/boir-preview collection-id filing-type type)
               (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
               (process-error))
    nil))

(derive :boir-efile-status :keechma/controller)
(defmethod ctrl/handle :boir-efile-status
  [{:keys [state*] :as ctrl} event {:keys [submission-id on-success]}]
  (case event
    :load (->> (api/ajaxp (str "/boir/file/" submission-id "/status/") {})
               (p/map (fn [response] 
                        (ctrl/transact ctrl #(reset! state* response))
                        (some-> on-success (apply []))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :boir-occurrence-submissions :keechma/controller)
(defmethod ctrl/handle :boir-occurrence-submissions
  [{:keys [state*] :as ctrl} event {:keys [occurrence-id on-success]}]
  (case event
    :load (->> (api/ajaxp (str "/boir/occurrence/" occurrence-id "/files/") {})
               (p/map (fn [response]
                        (ctrl/transact ctrl #(reset! state* response))
                        (some-> on-success (apply []))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :boir-occurrence-current-submission :keechma/controller)
(defmethod ctrl/handle :boir-occurrence-current-submission
  [{:keys [state*] :as ctrl} event {:keys [occurrence-id on-success on-error]}]
  (case event
    :load (->> (api/ajaxp (str "/boir/file/occurrence/" occurrence-id "/") {})
               (p/map (fn [response]
                        (ctrl/transact ctrl #(reset! state* response))
                        (some-> on-success (apply []))))
               (p/error (fn [e]
                          (if on-error
                            (apply on-error [e])
                            (if (= 404 (:status e))
                              (ctrl/transact ctrl #(reset! state* nil))
                              (throw e)))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :boir-submissions :keechma/controller)
(defmethod ctrl/handle :boir-submissions
  [{:keys [state*] :as ctrl} event params]
  (case event
    :load (->> (api/ajaxp (str "/boir/files/")
                          {:body (util/make-params  {:submission_id (:submission-id params)})
                           :method :post})
               (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :chart :keechma/controller)
(defmethod ctrl/handle :chart
  [{:keys [state*] :as ctrl} event {:keys [collection-id show-inactive]}]
  (case event
    :load (->> (api/ajaxp (str "/collection/" collection-id "/chart/")
                          {:params (util/remove-nil-values {:show_inactive show-inactive})})
               (p/map (fn [response]
                        (ctrl/transact ctrl #(reset! state* response))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :collection-review :keechma/controller)
(defmethod ctrl/handle :collection-review
  [{:keys [state*] :as ctrl} event {:keys [collection-id review-id on-success on-error]}]
  (case event
    :start (->> (api/ajaxp (str "/collection/" collection-id "/review/"
                                (when review-id (str "?review_id=" review-id)))
                           {:method :post})
                (p/map (fn [conversation-id]
                         (util/set-location (str "#/chat?conversation_id=" conversation-id))))
                (process-error))
    :delete-report (->> (api/ajaxp (str "/collection/" collection-id "/review/" review-id "/")
                                   {:method :delete})
                        (p/map (fn [_]
                                 (some-> on-success (apply []))))
                        (process-error))
    :discard (->> (api/ajaxp (str "/collection_review/" review-id "/discard/") {:method :post})
                  (p/map (fn [response]
                           (some-> on-success (apply [(:collection_id response)]))))
                  (p/error (fn [e]
                             (some-> on-error (apply []))
                             (throw e)))
                  (process-error))
    :clear (reset! state* nil)
    nil))

(defcontroller collections
  [{:keys [state*] :as ctrl} event params]
  (case event
    :load (let [{:keys [ids on-success]} params]
            (->>
              (p/all (mapv (fn [id] (model/collection-full-details id true)) ids))
              (p/map (fn [results]
                       (on-success results)))
              (process-error)))
    nil))
